import React, { useRef, useState, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, IconButton, TextField, MenuItem, FormControlLabel, Switch, Grid } from '@material-ui/core';
import { pRemoteControlOptions, pRepetitionRecord, speedCountDownTimer } from '../../utils/parameters';

import { makeStyles } from '@material-ui/core/styles';
import Tooltip from '@mui/material/Tooltip';
import CloseIcon from "@material-ui/icons/Close";
import "../../styles/devices/mob_SignDialog.css";
import { useTranslation } from "react-i18next";


const useStyles = makeStyles((theme) => ({
    dialogContent: {
        margin: theme.spacing(2),
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    formControlLabel: {
        marginTop: theme.spacing(1),
        justifyContent: "center",
    },
    gridContainer: {
        maxWidth: 350,
        margin: '0 auto',
        minWidth: 250,

    },
    inputField: {
      width: "80% !important",
    },
    labelSelect: {
      fontSize: "12px !important", // Ajuste el tamaño de fuente según sea necesario
    },
    centeredGrid: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginTop: 20
    },
  }));


export function SettingsDialog(props) {
  const { openDialog, handleClickClose, settings, setSettings} = props;
  const { t } = useTranslation("global")
  
  const styles = useStyles();

  const repetitions_video_available = { min: 1, max: 5}
  const timer_available = { min: 2, max: 5}

  const handleChange = (event, paramName) => {

    let value = ''
    switch(paramName) {
      case 'repetitions_video':
        value = event.target.value
        value = value < repetitions_video_available.min ? repetitions_video_available.min :  value
        value = value > repetitions_video_available.max ? repetitions_video_available.max :  value
        break;
      case 'timer':  
        value = event.target.value
        value = value < timer_available.min ? timer_available.min :  value
        value = value > timer_available.max ? timer_available.max :  value
        break;
      default:
        value = event.target.value
    }

    setSettings({ ...settings, [paramName]: value });
  };

  const handleSwitchChange = (event) => {
    setSettings({ ...settings, enable_discard: event.target.checked });
  };

  // useEffect(() => {
  //   console.log('open setting dialgo -> ', settings)
  // }, [settings]);

  return (
    <Dialog className="sig_SignModal_Dialog" open={openDialog} onClose={handleClickClose} maxWidth="sm">
      <DialogTitle>
        <div className={styles.titleContainer}>
          <IconButton aria-label="close" className="sig_Game_CloseButton" onClick={handleClickClose}>
            <CloseIcon />
          </IconButton>
          <div className={styles.title}>
            {t("sDonate.settings_title")}
          </div>
        </div>
      </DialogTitle>
      <DialogContent className={styles.dialogContent}>
        <Grid container spacing={3}  className={styles.gridContainer}>
          <Grid item xs={12} sm={6}>
            <Tooltip placement="left" title={t("sDonate.settings_repetitions")}>
              <TextField
                className={styles.inputField}
                label="Repetitions"
                type="number"
                InputProps={{ inputProps: repetitions_video_available }}
                value={settings.repetitions_video}
                onChange={(event) => handleChange(event, 'repetitions_video')}
                fullWidth
                margin="normal"
                InputLabelProps={{ style: { fontSize: '15px' } }}
              />
            </Tooltip>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Tooltip placement="right" title={t("sDonate.settings_speed")}>
              <TextField
                className={styles.inputField}
                select
                label="Countdown speed"
                value={settings.speedCountDownTimer}
                onChange={(event) => handleChange(event, 'speedCountDownTimer')}
                fullWidth
                margin="normal"
                InputLabelProps={{ style: { fontSize: '15px' } }}
                >
                {speedCountDownTimer.map((option) => (
                    <MenuItem key={option} value={option}>
                    {option}
                    </MenuItem>
                ))}
              </TextField>
            </Tooltip>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Tooltip placement="left" title={t("sDonate.settings_duration")}>
              <TextField
                  className={styles.inputField}
                  label="Countdown sec"
                  type="number"
                  InputProps={{ inputProps: timer_available }}
                  value={settings.timer}
                  onChange={(event) => handleChange(event, 'timer')}
                  fullWidth
                  margin="normal"
                  InputLabelProps={{ style: { fontSize: '15px' } }}
                  />
            </Tooltip>   
          </Grid>
          <Grid item xs={12} sm={6}>
            <Grid container className={styles.centeredGrid}>
              <Tooltip placement="right" title={t("sDonate.settings_btn_discard")}>
                <FormControlLabel
                    classes={{
                      label: styles.labelSelect
                    }}
                    control={
                        <>
                            < Switch color="primary" onClick={handleSwitchChange} checked={settings.enable_discard}/>
                        </>}
                    label= {settings.enable_discard ? "Remove button discard" : "Add button discard" }
                />
              </Tooltip>
            </Grid>
          </Grid>
          </Grid>

          <Grid container spacing={3}  className={styles.gridContainer}>
              <Grid item xs={12} sm={6}>
                <Tooltip placement="left" title={t("sDonate.settings_speed_progress")}>
                  <TextField
                    className={styles.inputField}
                    select
                    label="Mode remote"
                    value={settings.mode_remote} // aquí se utiliza el valor de settings.mode_remote
                    onChange={(event) => handleChange(event, 'mode_remote')}
                    fullWidth
                    margin="normal"
                    InputLabelProps={{ style: { fontSize: '15px' } }}
                  >
                    {Object.keys(pRemoteControlOptions).map((option) => (
                      <MenuItem key={option} value={pRemoteControlOptions[option]}>
                        <div style={{ fontSize: '12px' }}>{option}</div>
                      </MenuItem>
                    ))}
                  </TextField>
                </Tooltip>  
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Tooltip placement="right" title={t("sDonate.settings_actions")}>
                  <TextField
                    className={styles.inputField}
                    select
                    label="Record - repetition"
                    value={settings.repeat_after_record}
                    onChange={(event) => handleChange(event, 'repeat_after_record')}
                    fullWidth
                    margin="normal"
                    InputLabelProps={{ style: { fontSize: '14px' } }}
                  >
                    {Object.keys(pRepetitionRecord).map((option) => (
                      <MenuItem key={option} value={pRepetitionRecord[option]}>
                        <div style={{ fontSize: '12px' }}>{option}</div>
                      </MenuItem>
                    ))}
                  </TextField>
                </Tooltip>
              </Grid>
          </Grid>

      </DialogContent>
    </Dialog>
  );
}